var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "d-flex justify-content-between" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-3" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("SignaturesContainer", {
                attrs: {
                  signatures: _vm.signatures,
                  placeholder: "Buscar Firma"
                },
                model: {
                  value: _vm.signatureSelected,
                  callback: function($$v) {
                    _vm.signatureSelected = $$v
                  },
                  expression: "signatureSelected"
                }
              })
            ],
            1
          ),
          _vm.actions && _vm.actions.length > 0
            ? _c(
                "div",
                { staticClass: "col-12 mt-10" },
                [
                  _c("SignaturesContainer", {
                    attrs: {
                      signatures: _vm.actions,
                      placeholder: "Buscar acciones"
                    },
                    model: {
                      value: _vm.signatureSelected,
                      callback: function($$v) {
                        _vm.signatureSelected = $$v
                      },
                      expression: "signatureSelected"
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ]),
        _c(
          "div",
          { staticClass: "col-9" },
          [
            _c("PdfViewport", {
              attrs: {
                "default-page": 1,
                path: _vm.step.mainFile.path,
                name: _vm.step.mainFile.name,
                signatures: Object.values(_vm.step.signaturesDropped),
                "closable-sign": true,
                "signature-width": _vm.signatureWidth,
                "signature-height": _vm.signatureHeight,
                "signature-type": _vm.signatureType
              },
              on: {
                loaded: function($event) {
                  return _vm.$emit("loaded")
                },
                "page-click": _vm.onSignatureDropped,
                "signature-delete": _vm.onSignatureDelete,
                "signature-drag-end": _vm.onSignatureDragEnd
              }
            })
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }